import React, { useEffect, useState } from 'react';

import type { EmojiProvider } from '@atlaskit/emoji';
import { EmojiResource } from '@atlaskit/emoji/resource';

import { AudioContainer, DraggableAudio, useAudioPlayerStore } from '@atlassian/ai-audio';

import { getEmojiProvider } from '@confluence/fabric-providers/entry-points/EmojiProvider';
import { type WithFlagsProps, withFlags } from '@confluence/flags/entry-points/withFlags';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData';

import { audioFeatures } from '../../../entry-points/audioFeatures';

type AudioContainerWrapperProps = {} & WithFlagsProps;

export const FloatingAudioContainer = withFlags(({ flags }: AudioContainerWrapperProps) => {
	const { isOpen } = useAudioPlayerStore();
	const { activationId, userId, cloudId } = useSessionData();
	const [emojiProvider, setEmojiProvider] = useState<EmojiProvider | undefined>(undefined);

	useEffect(() => {
		//getEmojiProvider returns a promise, but getEmojiProvider requires it to be resolved. This middle step ensures the promise has returned before the value is passed
		getEmojiProvider(EmojiResource, { cloudId, userId })
			.then(setEmojiProvider)
			.catch(() => {});
	}, [cloudId, userId]);

	return isOpen && emojiProvider ? (
		<DraggableAudio>
			{({ isDragging }) => (
				<AudioContainer
					product="confluence"
					cloudId={cloudId}
					activationId={activationId}
					emojiProvider={emojiProvider}
					audioFeatures={audioFeatures}
					flags={flags as any}
					pinToExpandedView={isDragging}
				/>
			)}
		</DraggableAudio>
	) : null;
});
